import { IQService } from "angular";
import { getExceptionMessage } from "../../core/data-utils";
import { EmploymentProcessingService } from "../../core/services";
import { ProcessingState, ChangeHistoryVM, BatchProcessResult } from "./employment-processing-models";

export class EmployeeChangeHistoryProcessor {
    constructor(private $q: IQService, private employmentProcessingService: EmploymentProcessingService) {
        'ngInject';
    }

    batchProcessChangeHistory(changes: ChangeHistoryVM[]) {
        changes.forEach(c => c.processingState = ProcessingState.Processing);
        const items = changes.map(c => ({
            EmployeeID: c.EmployeeID,
            ChangeHistoryID: c.EmployeeChangeHistoryID
        }));
        return this.employmentProcessingService.processChangeRequestsBatch(items)
            .then(response => {
                const result = response.data as BatchProcessResult;
                // Mark succeeded
                changes
                    .filter(c => result.Succeeded.includes(c.EmployeeChangeHistoryID))
                    .forEach(c => {
                        c.processingState = ProcessingState.Processed;
                        c.isSelected = false;
                    });
                // Mark forbidden
                changes
                    .filter(c => result.Forbidden.includes(c.EmployeeChangeHistoryID))
                    .forEach(c => c.processingState = ProcessingState.Failed);

                return {
                    succeeded: result.Succeeded.length,
                    failed: result.Forbidden.length,
                    messages: result.Forbidden.length > 0 ? [result.Message] : [],
                    promises: []
                };
            })
            .catch(ex => {
                changes.forEach(c => c.processingState = ProcessingState.Failed);
                return {
                    succeeded: 0,
                    failed: changes.length,
                    messages: [getExceptionMessage(ex)],
                    promises: []
                };
            });
        //const chunkResult = changes.reduce((processingResult, change) => {
        //    change.processingState = ProcessingState.Processing;
        //    const saved = this.employmentProcessingService.processChangeRequests(change.EmployeeID, change.EmployeeChangeHistoryID)
        //        .then(() => {
        //            change.processingState = ProcessingState.Processed;
        //            change.isSelected = false;
        //            processingResult.succeeded++;
        //        })
        //        .catch(ex => {
        //            change.processingState = ProcessingState.Failed;
        //            processingResult.failed++;
        //            processingResult.messages.push(`failed to process ${change.EmployeeID}: `
        //                + getExceptionMessage(ex));
        //        });
        //    processingResult.promises.push(saved);
        //    return processingResult;
        //}, { succeeded: 0, failed: 0, messages: [], promises: [] });
        //return this.$q.all(chunkResult.promises)
        //    .then(() => chunkResult);
    }
}
